import { ClientConfig } from '../../config/ClientConfig'
import { HttpService } from '../http-service'
import { AuthService } from '../../auth/AuthService'

export const RingGameApiService = new (class {
	private playerId: string
	private baseUrl = `${ClientConfig.POKER_SERVER_RING_GAMES_URL}/ring-game/player/v1`

	async seatPlayer(gameId: string, seatId: string): Promise<string> {
		const playerId = await this.getPlayerId()
		const url = `${this.baseUrl}/games/${gameId}/players/${playerId}/seat-request`
		return HttpService.put(url, { seatId: seatId }, { authenticate: true })
	}

	async buyIn(gameId: string, amount: number, sitInOnComplete: boolean) {
		const playerId = await this.getPlayerId()
		const url = `${this.baseUrl}/games/${gameId}/players/${playerId}/buy-in-request`
		const request: BuyInRequest = { amount: amount.toString(), sitInOnComplete }
		return HttpService.put(url,  request , { authenticate: true })
	}

	async removePlayer(gameId: string): Promise<string> {
		const playerId = await this.getPlayerId()
		const url = `${this.baseUrl}/games/${gameId}/players/${playerId}/leave-request`
		return HttpService.put(url, { }, { authenticate: true })
	}

	private async getPlayerId(): Promise<string> {
		if (!this.playerId) this.playerId = await AuthService.getCurrentUserId()
		return this.playerId
	}
})()

type BuyInRequest = {
	amount: string
	sitInOnComplete: boolean
}
